<template>
  <div>
    <h3 class="headline text-center">
      {{ $t('dashboard.appointments.title') }}
    </h3>
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <div
      v-else-if="sortedWorkOrders.length > 0"
      class="appointments vertical-blurred-scroll"
    >
      <Appointment
        v-for="workOrder in sortedWorkOrders"
        :id="workOrder.id"
        :key="workOrder.id"
        :clientId="workOrder.site.client.ref"
        :siteId="workOrder.site.ref"
        :title="workOrder.site.name"
        :clientName="workOrder.site.client.name"
        :address="workOrder.site.address"
      />
    </div>
    <EmptyState
      v-else
      icon="calendar_today"
      :label="$t('dashboard.appointments.noData')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { sortBy } from 'lodash';
import EmptyState from '@/components/shared/widgets/EmptyState';
import Appointment from '@/components/dashboard/Appointment';

export default {
    components: {
        Appointment,
        EmptyState,
    },
    data() {
        return {
            workOrders: [],
            loading: false,
        };
    },
    computed: {
        ...mapGetters([
            'currentMember',
            'hasPermission',
        ]),
        todaysWorkOrders() {
            const today = new Date();

            return this.workOrders.filter(workOrder => moment(new Date(workOrder.startDate)).isSame(today, 'day'));
        },
        sortedWorkOrders() {
            return sortBy(this.todaysWorkOrders, workOrder => workOrder.startDate);
        },
    },
    created() {
        this.getWorkOrders();
    },
    methods: {
        formatTime(date) {
            return moment(date).format('LT');
        },
        async getWorkOrders() {
            this.loading = true;
            const queryParams = { showallattributes: !!this.hasPermission('showAllAttributes'), excludeActivities: true, member: this.currentMember.id };
            const { data } = await this.$rq.getWorkOrders(queryParams);
            this.workOrders = data.workOrders;
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
  .appointments {
    height: 830px;
  }
</style>
